import { WidgetProps } from '@rjsf/utils';
import { Input, Textarea } from '@amzn/awsui-components-react-v3';
import * as React from 'react';
import { getValueFromContext } from 'src/components/datausageagreement/widgets/OmniDUAContext';

export interface ConditionallyDisabledInputProps extends WidgetProps {}

export function ConditionallyDisabledInput(props: ConditionallyDisabledInputProps) {
  const contextField = props.schema.omniContextField;
  const placeholder = props.schema.placeholder;
  const displayAs = props.schema.displayAs;

  // if a value is already provided (for example in request context details page), display that
  let valueFromContext: string;
  if (!!contextField) {
    valueFromContext = getValueFromContext(props.formContext?.omniContext, contextField);
  }

  const isOverwritten = !!valueFromContext;
  const inputValue = isOverwritten ? valueFromContext : props.value;

  if (isOverwritten) {
    props.onChange(valueFromContext);
  }

  return displayAs === 'textarea' ? (
    <Textarea
      disabled={!!contextField || props.readonly}
      readOnly={!!contextField || props.readonly}
      onChange={(event) => {
        if (!isOverwritten) {
          props.onChange(event.detail.value);
        }
      }}
      rows={4}
      value={inputValue}
      placeholder={placeholder}
    />
  ) : (
    <Input
      disabled={!!contextField || props.readonly}
      readOnly={!!contextField || props.readonly}
      onChange={(event) => {
        if (!isOverwritten) {
          props.onChange(event.detail.value);
        }
      }}
      value={inputValue}
      placeholder={placeholder}
    />
  );
}
